import { MediumText } from "../../../../../components/typography";

export default function HistoryItemPaymentTab() {
    return (
        <MediumText>Історія платежів елемент</MediumText>
    )
}